import { type FilterGroup } from '@kijiji/generated/graphql-types'

import { FILTER_CANONICAL } from '@/constants/search'

const { CATEGORY_SECTION, PRICE_SECTION, LOCATION_SECTION, ADTYPE_SECTION } = FILTER_CANONICAL

export const getQuickFilters = (filters: FilterGroup[]) => {
  if (!filters) return []

  const MAX_QUICK_FILTERS = 5

  const excludedSections: string[] = [LOCATION_SECTION, ADTYPE_SECTION]

  const quickFilterGroups = [...filters]
    .filter(({ name }) => !excludedSections.includes(name))
    .sort((a, b) => {
      // Category and price filters should always be first
      if (b.name === CATEGORY_SECTION || b.name === PRICE_SECTION) return 1
      if (a.name === CATEGORY_SECTION || a.name === PRICE_SECTION) return -1

      if (!a.quickFilterSortOrder) return 1
      if (!b.quickFilterSortOrder) return -1

      return a.quickFilterSortOrder - b.quickFilterSortOrder
    })
    .slice(0, MAX_QUICK_FILTERS)

  const quickFilters = quickFilterGroups.flatMap((group) => group.filters)

  return quickFilters.slice(0, MAX_QUICK_FILTERS)
}
